// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3s6bk","choiceBoxes":"toolbarselects_choiceBoxes__331tM","simpleField":"toolbarselects_simpleField__arg3p"};